import _classCallCheck from "/codebuild/output/src3305341033/src/hvorigins/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/codebuild/output/src3305341033/src/hvorigins/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/codebuild/output/src3305341033/src/hvorigins/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/codebuild/output/src3305341033/src/hvorigins/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/codebuild/output/src3305341033/src/hvorigins/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/codebuild/output/src3305341033/src/hvorigins/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _regeneratorRuntime from "/codebuild/output/src3305341033/src/hvorigins/node_modules/@babel/runtime/regenerator";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

import Wallet from '@project-serum/sol-wallet-adapter';
import { BaseMessageSignerWalletAdapter, pollUntilReady, WalletAdapterNetwork, WalletConnectionError, WalletDisconnectedError, WalletDisconnectionError, WalletError, WalletNotConnectedError, WalletNotFoundError, WalletSignMessageError, WalletSignTransactionError, WalletTimeoutError, WalletWindowBlockedError, WalletWindowClosedError } from '@solana/wallet-adapter-base';
export var SolletWalletAdapter = /*#__PURE__*/function (_BaseMessageSignerWal) {
  _inherits(SolletWalletAdapter, _BaseMessageSignerWal);

  var _super = _createSuper(SolletWalletAdapter);

  function SolletWalletAdapter() {
    var _this;

    var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, SolletWalletAdapter);

    _this = _super.call(this);

    _this._disconnected = function () {
      var wallet = _this._wallet;

      if (wallet) {
        wallet.off('disconnect', _this._disconnected);
        _this._wallet = null;

        _this.emit('error', new WalletDisconnectedError());

        _this.emit('disconnect');
      }
    };

    _this._provider = config.provider || (typeof window === 'undefined' ? undefined : window.sollet);
    _this._network = config.network || WalletAdapterNetwork.Mainnet;
    _this._connecting = false;
    _this._wallet = null;
    if (!_this.ready) pollUntilReady(_assertThisInitialized(_this), config.pollInterval || 1000, config.pollCount || 3);
    return _this;
  }

  _createClass(SolletWalletAdapter, [{
    key: "publicKey",
    get: function get() {
      var _a;

      return ((_a = this._wallet) === null || _a === void 0 ? void 0 : _a.publicKey) || null;
    }
  }, {
    key: "ready",
    get: function get() {
      var _a;

      return typeof this._provider === 'string' || typeof window !== 'undefined' && typeof ((_a = window.sollet) === null || _a === void 0 ? void 0 : _a.postMessage) === 'function';
    }
  }, {
    key: "connecting",
    get: function get() {
      return this._connecting;
    }
  }, {
    key: "connected",
    get: function get() {
      var _a;

      return !!((_a = this._wallet) === null || _a === void 0 ? void 0 : _a.connected);
    }
  }, {
    key: "connect",
    value: function connect() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var provider, wallet, handleDisconnect, timeout, interval;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;

                if (!(this.connected || this.connecting)) {
                  _context.next = 3;
                  break;
                }

                return _context.abrupt("return");

              case 3:
                this._connecting = true;
                provider = this._provider || typeof window !== 'undefined' && window.sollet;

                if (provider) {
                  _context.next = 7;
                  break;
                }

                throw new WalletNotFoundError();

              case 7:
                _context.prev = 7;
                wallet = new Wallet(provider, this._network); // HACK: sol-wallet-adapter doesn't reject or emit an event if the popup or extension is closed or blocked

                handleDisconnect = wallet.handleDisconnect;
                _context.prev = 10;
                _context.next = 13;
                return new Promise(function (resolve, reject) {
                  var connect = function connect() {
                    if (timeout) clearTimeout(timeout);
                    wallet.off('connect', connect);
                    resolve();
                  };

                  wallet.handleDisconnect = function () {
                    wallet.off('connect', connect);
                    reject(new WalletWindowClosedError());

                    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
                      args[_key] = arguments[_key];
                    }

                    return handleDisconnect.apply(wallet, args);
                  };

                  wallet.on('connect', connect);
                  wallet.connect().catch(function (reason) {
                    wallet.off('connect', connect);
                    reject(reason);
                  });

                  if (typeof provider === 'string') {
                    var count = 0;
                    interval = setInterval(function () {
                      var popup = wallet._popup;

                      if (popup) {
                        if (popup.closed) reject(new WalletWindowClosedError());
                      } else {
                        if (count > 50) reject(new WalletWindowBlockedError());
                      }

                      count++;
                    }, 100);
                  } else {
                    // HACK: sol-wallet-adapter doesn't reject or emit an event if the extension is closed or ignored
                    timeout = setTimeout(function () {
                      return reject(new WalletTimeoutError());
                    }, 10000);
                  }
                });

              case 13:
                _context.prev = 13;
                wallet.handleDisconnect = handleDisconnect;
                if (interval) clearInterval(interval);
                return _context.finish(13);

              case 17:
                _context.next = 24;
                break;

              case 19:
                _context.prev = 19;
                _context.t0 = _context["catch"](7);

                if (!(_context.t0 instanceof WalletError)) {
                  _context.next = 23;
                  break;
                }

                throw _context.t0;

              case 23:
                throw new WalletConnectionError(_context.t0 === null || _context.t0 === void 0 ? void 0 : _context.t0.message, _context.t0);

              case 24:
                wallet.on('disconnect', this._disconnected);
                this._wallet = wallet;
                this.emit('connect');
                _context.next = 33;
                break;

              case 29:
                _context.prev = 29;
                _context.t1 = _context["catch"](0);
                this.emit('error', _context.t1);
                throw _context.t1;

              case 33:
                _context.prev = 33;
                this._connecting = false;
                return _context.finish(33);

              case 36:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 29, 33, 36], [7, 19], [10,, 13, 17]]);
      }));
    }
  }, {
    key: "disconnect",
    value: function disconnect() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var wallet, handleDisconnect;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                wallet = this._wallet;

                if (!wallet) {
                  _context2.next = 16;
                  break;
                }

                wallet.off('disconnect', this._disconnected);
                this._wallet = null; // HACK: sol-wallet-adapter doesn't reliably fulfill its promise or emit an event on disconnect

                handleDisconnect = wallet.handleDisconnect;
                _context2.prev = 5;
                _context2.next = 8;
                return new Promise(function (resolve, reject) {
                  var timeout = setTimeout(function () {
                    return resolve();
                  }, 250);

                  wallet.handleDisconnect = function () {
                    clearTimeout(timeout);
                    resolve(); // HACK: sol-wallet-adapter rejects with an uncaught promise error

                    // HACK: sol-wallet-adapter rejects with an uncaught promise error
                    wallet._responsePromises = new Map();

                    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
                      args[_key2] = arguments[_key2];
                    }

                    return handleDisconnect.apply(wallet, args);
                  };

                  wallet.disconnect().then(function () {
                    clearTimeout(timeout);
                    resolve();
                  }, function (error) {
                    clearTimeout(timeout); // HACK: sol-wallet-adapter rejects with an error on disconnect

                    // HACK: sol-wallet-adapter rejects with an error on disconnect
                    if ((error === null || error === void 0 ? void 0 : error.message) === 'Wallet disconnected') {
                      resolve();
                    } else {
                      reject(error);
                    }
                  });
                });

              case 8:
                _context2.next = 13;
                break;

              case 10:
                _context2.prev = 10;
                _context2.t0 = _context2["catch"](5);
                this.emit('error', new WalletDisconnectionError(_context2.t0 === null || _context2.t0 === void 0 ? void 0 : _context2.t0.message, _context2.t0));

              case 13:
                _context2.prev = 13;
                wallet.handleDisconnect = handleDisconnect;
                return _context2.finish(13);

              case 16:
                this.emit('disconnect');

              case 17:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[5, 10, 13, 16]]);
      }));
    }
  }, {
    key: "signTransaction",
    value: function signTransaction(transaction) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var wallet;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                wallet = this._wallet;

                if (wallet) {
                  _context3.next = 4;
                  break;
                }

                throw new WalletNotConnectedError();

              case 4:
                _context3.prev = 4;
                _context3.next = 7;
                return wallet.signTransaction(transaction);

              case 7:
                _context3.t0 = _context3.sent;

                if (_context3.t0) {
                  _context3.next = 10;
                  break;
                }

                _context3.t0 = transaction;

              case 10:
                return _context3.abrupt("return", _context3.t0);

              case 13:
                _context3.prev = 13;
                _context3.t1 = _context3["catch"](4);
                throw new WalletSignTransactionError(_context3.t1 === null || _context3.t1 === void 0 ? void 0 : _context3.t1.message, _context3.t1);

              case 16:
                _context3.next = 22;
                break;

              case 18:
                _context3.prev = 18;
                _context3.t2 = _context3["catch"](0);
                this.emit('error', _context3.t2);
                throw _context3.t2;

              case 22:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[0, 18], [4, 13]]);
      }));
    }
  }, {
    key: "signAllTransactions",
    value: function signAllTransactions(transactions) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var wallet;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;
                wallet = this._wallet;

                if (wallet) {
                  _context4.next = 4;
                  break;
                }

                throw new WalletNotConnectedError();

              case 4:
                _context4.prev = 4;
                _context4.next = 7;
                return wallet.signAllTransactions(transactions);

              case 7:
                _context4.t0 = _context4.sent;

                if (_context4.t0) {
                  _context4.next = 10;
                  break;
                }

                _context4.t0 = transactions;

              case 10:
                return _context4.abrupt("return", _context4.t0);

              case 13:
                _context4.prev = 13;
                _context4.t1 = _context4["catch"](4);
                throw new WalletSignTransactionError(_context4.t1 === null || _context4.t1 === void 0 ? void 0 : _context4.t1.message, _context4.t1);

              case 16:
                _context4.next = 22;
                break;

              case 18:
                _context4.prev = 18;
                _context4.t2 = _context4["catch"](0);
                this.emit('error', _context4.t2);
                throw _context4.t2;

              case 22:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[0, 18], [4, 13]]);
      }));
    }
  }, {
    key: "signMessage",
    value: function signMessage(message) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        var wallet, _yield$wallet$sign, signature;

        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.prev = 0;
                wallet = this._wallet;

                if (wallet) {
                  _context5.next = 4;
                  break;
                }

                throw new WalletNotConnectedError();

              case 4:
                _context5.prev = 4;
                _context5.next = 7;
                return wallet.sign(message, 'utf8');

              case 7:
                _yield$wallet$sign = _context5.sent;
                signature = _yield$wallet$sign.signature;
                return _context5.abrupt("return", Uint8Array.from(signature));

              case 12:
                _context5.prev = 12;
                _context5.t0 = _context5["catch"](4);
                throw new WalletSignMessageError(_context5.t0 === null || _context5.t0 === void 0 ? void 0 : _context5.t0.message, _context5.t0);

              case 15:
                _context5.next = 21;
                break;

              case 17:
                _context5.prev = 17;
                _context5.t1 = _context5["catch"](0);
                this.emit('error', _context5.t1);
                throw _context5.t1;

              case 21:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this, [[0, 17], [4, 12]]);
      }));
    }
  }]);

  return SolletWalletAdapter;
}(BaseMessageSignerWalletAdapter);